import React, { useState } from "react";
import axios from "axios";
import LoginPage from "../../components/Account/Login";
import { ValLogin } from "../../validation/UserValidation";
import {
  headers,
  setStorage,
  setStorageEmail,
  setStorageExp,
} from "../../libs";
import { useHistory } from "react-router-dom";
import ToastError from "../../components/Notification/ToastError";

function Login() {
  const history = useHistory();

  const [data, setData] = useState({ email: "", password: "" });
  const [isError, setError] = useState([]);
  const [loading, setLoading] = useState(false);

  const [view, setView] = useState(false);

  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const onError = () => {
    setOpen(false);
  };

  const onChange = (e) => {
    const { value, name } = e.target;

    setData({ ...data, [name]: value });
    setError([]);
  };

  const onView = () => {
    if (view) {
      setView(false);
    } else {
      setView(true);
    }
  };

  const onSubmit = async () => {
    const error = await ValLogin(data);
    setLoading(true);

    if (error.length > 0) {
      setError(error);
      setLoading(false);
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/login`,
          data,
          { headers: await headers(data) }
        );

        if (Number(response.data.code) === 200) {
          await setStorage(response.data.access_token);
          await setStorageEmail(response.data.data.email);
          await setStorageExp(response.data.expires_at);

          if (
            !response.data.data.alamat ||
            !response.data.data.kecamatan ||
            !response.data.data.gender ||
            !response.data.data.kelurahan ||
            !response.data.data.kodepos ||
            !response.data.data.kota ||
            !response.data.data.provinsi ||
            !response.data.data.tempat_lahir ||
            !response.data.data.tgl_lahir
          ) {
            setTimeout(() => {
              history.push("/profile");
              setLoading(false);
              onReset();
            }, 4500);
          } else {
            setTimeout(() => {
              history.push("/");
              setLoading(false);
              onReset();
            }, 4500);
          }
        } else {
          setLoading(false);
          setOpen(true);
          setResponse(response.data.message);
        }
      } catch (e) {
        setLoading(false);

        setOpen(true);
        setResponse("");
      }
    }
  };

  const onReset = () => {
    setView(false);
    setData({ email: "", password: "" });
  };

  return (
    <>
      <ToastError props={{ open, response, onError }} />
      <LoginPage
        props={{
          view,
          isError,
          loading,
          onChange,
          onView,
          onSubmit,
        }}
      />
    </>
  );
}

export default Login;
